import React from "react";
import "./Faculty.css";
import { Link } from "react-router-dom";

const Faculty = () => {
  // Sample Data
  const professors = [
    {
      id: 1214,
      name: "Dr. B.Sridhar",
      qualification: "M.Tech., Ph.D.",
      designation: "Professor & HOD",
    },
    {
      id: 1215,
      name: "Dr. Ramesh Kumar",
      qualification: "M.Tech., Ph.D.",
      designation: "Professor",
    },
  ];

  const associateProfessors = [
    {
      id: 2214,
      name: "Dr. Anitha Rao",
      qualification: "M.Tech., Ph.D.",
      designation: "Associate Professor",
    },
    {
      id: 2215,
      name: "Dr. Rajesh",
      qualification: "M.Tech., Ph.D.",
      designation: "Associate Professor",
    },
  ];

  // Reusable Table Component
  const FacultyTable = ({ title, data }) => (
    <div className="table table-responsive">
      <h5>{title}</h5>
      <table className="table table-bordered">
        <thead className="table-dark">
          <tr>
            <th scope="col">Staff ID</th>
            <th scope="col">Name</th>
            <th scope="col">Qualification</th>
            <th scope="col">Designation</th>
            <th scope="col">Profile</th>
          </tr>
        </thead>
        <tbody>
          {data.map((faculty) => (
            <tr key={faculty.id}>
              <td>{faculty.id}</td>
              <th scope="row">{faculty.name}</th>
              <td>{faculty.qualification}</td>
              <td>{faculty.designation}</td>
              <td>
                <Link
                  to={`/FacultyDetails/${faculty.id}`}
                  className="btn btn-info btn-sm"
                >
                  View
                </Link>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );

  return (
    <div className="faculty-section">
      <h2>Faculties</h2>
      <FacultyTable title="Professors" data={professors} />
      <FacultyTable title="Associate Professors" data={associateProfessors} />
    </div>
  );
};

export default Faculty;
